<ng-container *ngIf="prize">
    <div class="w-100 border border-2 px-4 py-2 my-2 rounded-4 d-flex align-items-center bg-white">
        <div class="w-100 d-flex justify-content-between align-items-center">
            <div class="fw-bold me-2">
                <img [src]="prize.image_url" height="64" alt="prize-image"/>
                {{ prize.name }}
            </div>

            <div>
                <span>{{ prize.description }}</span>
            </div>
        </div>
    </div>
</ng-container>
